<div class="liberro-placeholder-content">
  @if (icon) {
    <div class="liberro-placeholder-content__icon-bg">
      <svg-icon
        [src]="'assets/icons/' + icon"
      ></svg-icon>
    </div>
  }

  @if (title) {
    <div class="liberro-placeholder-content__header">
      {{ title }}
    </div>
  }

  <div class="liberro-placeholder-content__subheader">
    <ng-content></ng-content>
  </div>
</div>

